module.exports = __webpack_public_path__ + "static/img/25-3.9d04649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/25-3.jpg
// module id = pbzA
// module chunks = 0